import React, { FC } from "react";

export const DownloadCloudIcon: FC = () => {
  return (
    <svg
      version="1.1"
      id="Laag_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
      width="40"
      height="50"
    >
      <g>
        <path
          fill="#575756"
          d="M49.22,22.21c-1.57-3.72-5.22-6.18-9.3-6.18c-1.83,0-3.63,0.5-5.19,1.44c-2.06-5.11-7.09-8.57-12.67-8.57
		c-7.53,0-13.66,6.12-13.66,13.65c-4.29,1.22-7.33,5.17-7.33,9.71c0,5.57,4.53,10.1,10.1,10.1h10.23c-0.21-0.65-0.19-1.36,0.06-2
		H11.17c-4.46,0-8.1-3.63-8.1-8.1c0-3.87,2.76-7.21,6.56-7.94c0.49-0.1,0.84-0.54,0.81-1.04l-0.01-0.2
		c-0.01-0.17-0.02-0.34-0.02-0.51c0-6.43,5.23-11.66,11.66-11.66c5.16,0,9.76,3.46,11.19,8.42c0.09,0.32,0.34,0.58,0.66,0.68
		c0.32,0.1,0.67,0.04,0.93-0.18c1.45-1.17,3.21-1.79,5.07-1.79c3.45,0,6.53,2.2,7.65,5.47c0.14,0.4,0.51,0.67,0.93,0.67
		c4.38,0.08,7.95,3.71,7.95,8.09c0,4.46-3.63,8.1-8.1,8.1H38.06c0.25,0.64,0.27,1.35,0.06,2h10.23c5.57,0,10.1-4.53,10.1-10.1
		C58.44,27.03,54.36,22.66,49.22,22.21z"
        />
        <path
          fill="#575756"
          d="M34.57,40.75l-3.81,3.87v-9.11c0-0.55-0.45-1-1-1s-1,0.45-1,1v9.05l-3.81-3.81c-0.39-0.39-1.02-0.39-1.41,0
		s-0.39,1.02,0,1.41l4.85,4.85c0.38,0.38,0.88,0.57,1.38,0.57c0.5,0,1-0.19,1.38-0.57l4.85-4.85c0.39-0.39,0.39-1.02,0-1.41
		S34.96,40.36,34.57,40.75z"
        />
        <path
          fill="#575756"
          d="M35.27,49.03H24.24c-0.55,0-1,0.45-1,1s0.45,1,1,1h11.03c0.55,0,1-0.45,1-1S35.83,49.03,35.27,49.03z"
        />
      </g>
    </svg>
  );
};
